"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = require("../Box");
var Divider = function (props) {
    var margin = props.margin, width = props.width;
    return react_1.default.createElement(Box_1.Box, { margin: margin, width: width, border: "bottom" });
};
exports.Divider = Divider;
Divider.defaultProps = {
    width: '100%'
};
//# sourceMappingURL=Divider.js.map